import EventViewTestimonials from './EventViewTestimonials';

export default EventViewTestimonials;
